<template>
  <v-card>
    <v-form
      lazy-validation
      ref="form"
      v-model="validForm"
      @submit.prevent="onConfirm"
    >
      <v-card-title primary-title>
        Redigera underkategori
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              :rules="[validationRules.required]"
              v-model="model.name"
              label="Underkategori"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select
              item-text="name"
              item-value="uuid"
              :items="Object.values(categoryGroups)"
              v-model="model.category_group_uuid"
              label="Kategorigrupp"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onClose">
          Avbryt
        </v-btn>
        <v-btn type="submit" color="primary" text>
          Uppdatera
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import UPDATE_CATEGORY from '@/gql/categories/mutations/UpdateCategory.gql'
import { validationRules } from '@/common/validationRules'
import { get } from 'vuex-pathify'

export default {
  name: 'MasterdataSubCategoriesEdit',

  props: {
    uuid: String,
  },

  data() {
    return {
      validationRules,
      validForm: true,
      model: {
        name: '',
        category_group_uuid: null,
      },
    }
  },

  created() {
    for (let prop in this.model) {
      this.model[prop] = this.categories[this.uuid][prop]
    }
  },

  computed: {
    categories: get('categories/data'),
    categoryGroups: get('categoryGroups/data'),
  },

  methods: {
    async onConfirm() {
      const valid = await this.$refs.form.validate()
      if (!valid) return
      this.updateCategory()
      this.onClose()
    },

    onClose() {
      this.$emit('close')
    },

    updateCategory() {
      return this.$apollo.mutate({
        mutation: UPDATE_CATEGORY,
        variables: {
          uuid: this.uuid,
          payload: this.model,
        },

        update: (store, { data }) => {
          this.$store.set('categories/data', {
            ...this.$store.get('categories/data'),
            [data.updateCategory.uuid]: data.updateCategory,
          })
        },
      })
    },
  },
}
</script>
